/*
 *
 * AnnouncementPageContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import queryString from 'query-string';
import {makeSelectRoles, makeSelectAccountId} from 'domain/User/selectors';
import injectReducer from "utils/injectReducer";
import injectSaga from "utils/injectSaga";
import saga from "./sagas";
import {compose} from "redux";
import getAnnouncementPage from "./getAnnouncementPage";
import {makeSelectBreakpoint} from "domain/Screen/selectors";


export class AnnouncementPageContainer extends React.PureComponent {
    render() {
        const {accountId, userRoles, match: {params}, ...restProps} = this.props;
        const {view: viewName = 'all'} = queryString.parse(this.props.location.search);
        const props = {viewName, userRoles, params, ...restProps, accountId};
        return getAnnouncementPage(accountId, props)
    }
}

AnnouncementPageContainer.propTypes = {
    location: PropTypes.object.isRequired,
    accountId: PropTypes.string,
    userRoles: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    accountId: makeSelectAccountId(),
    userRoles: makeSelectRoles(),
    breakpoint: makeSelectBreakpoint(),
});

const reducer = (state = {}) => state;
const withReducer = injectReducer({key: 'announcementPage', reducer});
const withSaga = injectSaga({key: 'announcementPage', saga});
const withConnect = connect(mapStateToProps);

export default compose(
    withReducer,
    withSaga,
    withConnect,
)(AnnouncementPageContainer);
